import { ButtonProps } from '@mui/material';
import PDFObject from 'pdfobject';
import { useMemo } from 'react';
import { PDF_FILE_TYPE } from './fileTypes';
import { getFileExtension } from '@shared/utils';
import { Attachment } from '@dap/sanity/types';
import AttachmentButton from './AttachmentButton';

interface Props extends Attachment {
  onClick?: () => void;
  filename?: string;
  sx?: ButtonProps['sx'];
}

export default function SanityAttachment({ label, url, onClick, filename, sx }: Props) {
  const fileExtension = useMemo(() => getFileExtension(url), [url]);
  const fileType = useMemo(() => getFileExtension(url), [url]);
  const fileName = filename ?? `${label}.${fileType}`;
  const downloadUrl = `${url}?dl=${fileName}`;

  if (fileType === PDF_FILE_TYPE && PDFObject.supportsPDFs && onClick) {
    return (
      <AttachmentButton onClick={onClick} extension={fileExtension ?? ''} sx={sx}>
        {label}
      </AttachmentButton>
    );
  }

  return (
    <AttachmentButton
      extension={fileExtension ?? ''}
      href={downloadUrl}
      download={filename}
      sx={sx}
    >
      {fileName}
    </AttachmentButton>
  );
}
